import PriceDisplay from './PricesDisplay';

export default PriceDisplay;


// WEBPACK FOOTER //
// ./src/components/Others/PricesDisplay/index.tsx